import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withFetch } from '@angular/common/http';
import { QuicklinkModule } from 'ngx-quicklink';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '@environments/environment';
import { AppComponent } from './app.component';

/* Custom Modules */
import { MaterialModule } from '@material/material.module';
import { SharedModule } from '@shared/shared.module';
import { AngularFireModule } from '@angular/fire/compat';

import { StoreModule as NgRxStoreModule } from '@ngrx/store';
import { reducers } from '@shared/redux/config-store-state.model';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

/* Services */
import { AppConfigService, servicesOnRun } from '@shared/services/app-config.service';
import { TokenInterceptor } from '@shared/interceptors/token.interceptor';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    QuicklinkModule,
    SharedModule,
    MaterialModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    NgRxStoreModule.forRoot(reducers),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production
    }),
    TranslateModule.forRoot({
      fallbackLang: 'es-ar',
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      })
    }),
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideAppInitializer(
      () => {
        const initializerFn = (servicesOnRun)(inject(AppConfigService));
        return initializerFn();
      }
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule {
  constructor(private translate: TranslateService) {
    this.translate.setFallbackLang('es-ar');
    this.translate.use('es-ar');
  }
}
